// @core/api/endpoints/landing/get_landing_analytics.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingAnalyticsResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Get landing page analytics
 * Returns aggregated analytics: views, unique visitors, bounce rate, section engagement, and conversion metrics.
 */
export async function GetLandingAnalytics(
  page_id: string,
  options?: RequestOptions
): Promise<LandingAnalyticsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/landing/pages/:page_id/analytics`;
  requestPath = requestPath.replace(':page_id', encodeURIComponent(page_id));
  const requestOptions = options;
  return client.get<LandingAnalyticsResponse>(requestPath, { ...requestOptions });
}
